var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqIconDis({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.142 22.362h-4.38c-.637 0-1.114.478-1.114 1.115s.477 1.115 1.114 1.115h4.38c.637 0 1.115-.478 1.115-1.115s-.478-1.115-1.115-1.115zM12.48 3.968c-3.027.558-5.416 3.026-5.973 5.973-.557 2.946.557 5.574 2.548 7.246.398.318.557.796.557 1.274v.955c0 .956.797 1.752 1.752 1.752h5.256c.955 0 1.752-.796 1.752-1.752v-.955c0-.478.159-.956.557-1.274 1.672-1.434 2.707-3.504 2.707-5.813 0-4.619-4.3-8.361-9.157-7.406zm1.034 12.582-.08-3.663h-1.672l.956-4.3h2.787l-.956 3.026h1.673l-2.708 4.937z",
    fill: "#ABABAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqIconDis);
export default __webpack_public_path__ + "static/media/faqIcon-dis.d0f059fc6fd82a2911c6f66dc9d470f6.svg";
export { ForwardRef as ReactComponent };